import React from "react";
import AuthButton from '../AuthButton/AuthButton';
import LoggedAs from '../LoggedAs/LoggedAs';
import { Link } from "react-router-dom";

export default function NavBar() {
  return (
    <div className="nav-container mb-3">
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
        <Link className="navbar-brand" to="/" >Autosnow</Link>
          <div className="d-flex align-items-center">
            <LoggedAs />
            <AuthButton />
          </div>
        </div>
      </nav>
    </div>
  );
};
